import '../DeepAnalysis.less';
import React from 'react';
import { Spin, Icon } from 'antd';

type Props = {
    description?: string;
};

export default function LoaderCard({ description }: Props) {
    return (
        <div className="deep-analysis-loader-card">
            <Spin
                indicator={
                    <Icon
                        data-cy="loader"
                        type="loading"
                        spin
                    />
                }
            />
            {description && <h1>{description}</h1>}
        </div>
    );
}
